// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host .sidenav-submenu-btn {
  position: relative;
}
:host .sidenav-submenu-item {
  width: unset;
  min-height: unset;
  height: unset;
}
:host .sidenav-submenu-icon {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
}
:host .submenu-list {
  padding: 0;
  margin: 0;
  list-style: none;
}`, "",{"version":3,"sources":["webpack://./src/app/sidenav/sidenav.component.scss","webpack://./../../../../%E6%9D%AD%E5%B7%9E%E6%95%B0%E7%BA%B3%E5%B7%9D/IccpPlatform/fuxa/client/src/app/sidenav/sidenav.component.scss"],"names":[],"mappings":"AACI;EACI,kBAAA;ACAR;ADGI;EACI,YAAA;EACA,iBAAA;EACA,aAAA;ACDR;ADII;EACI,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;ACFR;ADII;EACI,UAAA;EACA,SAAA;EACA,gBAAA;ACFR","sourcesContent":[":host {\n    .sidenav-submenu-btn {\n        position: relative;\n    }\n\n    .sidenav-submenu-item {\n        width: unset;\n        min-height: unset;\n        height: unset;\n    }\n\n    .sidenav-submenu-icon {\n        position: absolute;\n        right: 12px;\n        top: 50%;\n        transform: translateY(-50%);\n    }\n    .submenu-list {\n        padding: 0;\n        margin: 0;\n        list-style: none;\n    }\n}",":host .sidenav-submenu-btn {\n  position: relative;\n}\n:host .sidenav-submenu-item {\n  width: unset;\n  min-height: unset;\n  height: unset;\n}\n:host .sidenav-submenu-icon {\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n}\n:host .submenu-list {\n  padding: 0;\n  margin: 0;\n  list-style: none;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
